<template>
    <div class="pageContentMargin pageBigMarginBottom">
      <VTitle
        :val='title'
        :showAll="showAll"
        :showLine='show'
      />
      <div class="pageUserShadow msgCard">
        <slot name="form" />
        <KBtn
          v-if="show"
          size="big"
          :title='btnText'
          color='var(--redColor)'
          @click="onClick"
        />
      </div>
    </div>
</template>

<script>
export default {
    props: {
      showAll:{
        type:Boolean,
        default:()=>true
      },
      show:{
        type:Boolean,
        default:()=>true
      },
      title: String,
      btnText: {
        type: String,
        default: '保存'
      }
    },
    mounted() {

    },
    methods: {
      onClick() {
        this.$emit('click')
      }
    },
};
</script>

<style scoped lang="less">
h3 {
  font-size: 20px;
  font-weight: 700;
}
.msgCard {
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  .van-button{
    margin-top: 5px;
  }
}
</style>
